module.exports = __webpack_public_path__ + "img/sp5.1a1ac559.svg";